import React from 'react'
export const MessageIcon = () => {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.589844" width="48" height="48" rx="24" fill="url(#paint0_linear_6899_29439)" />
      <path
        d="M13.6367 27.6296C13.6367 29.7006 15.3157 31.3796 17.3867 31.3796H21.3632V28.3796H17.3867C16.9725 28.3796 16.6367 28.0438 16.6367 27.6296V18.6438C16.6367 18.2296 16.9725 17.8938 17.3867 17.8938H31.7927C32.2069 17.8938 32.5427 18.2296 32.5427 18.6438V27.6296C32.5427 28.0438 32.2069 28.3796 31.7927 28.3796H26.0461L21.3632 32.3191V33.3679V36.1062L27.2289 31.3796H31.7927C33.8638 31.3796 35.5427 29.7006 35.5427 27.6296V18.6438C35.5427 16.5728 33.8638 14.8938 31.7927 14.8938H17.3867C15.3157 14.8938 13.6367 16.5728 13.6367 18.6438V27.6296Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6899_29439"
          x1="0.589844"
          y1="0"
          x2="55.2324"
          y2="57.2964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E691" />
          <stop offset="1" stopColor="#0145FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
